/**
 * @name crud_contracts.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_contracts.js
 */

//import { apiCall, getBaseDir } from './crud_contracts.js';

import TableBuilder from '../../table_builder.js';
import Swal from 'sweetalert2';

var getBaseDir = null, apiCall = null, enableForm = null, disableForm = null, getContractStatusName = null, getBusinessDoctorsListByBranchId= null, getBranchNameFromId = null, userHasRole = null, escapeSingleQuotes = null;
var moment = require('moment-timezone');

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        enableForm = utils.enableForm;
        disableForm = utils.disableForm;
        getContractStatusName = utils.getContractStatusName;
        getBusinessDoctorsListByBranchId = utils.getBusinessDoctorsListByBranchId;
        getBranchNameFromId = utils.getBranchNameFromId;
        userHasRole = utils.userHasRole;
        escapeSingleQuotes = utils.escapeSingleQuotes;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'contratos/com-atendimento-sem-upload')
            return;

        new Contracts(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class Contracts
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.operatorAllowedServices = [];
        this.selectedBranch = -1;
        this.businessPlans = [];
        this.currentFlowInterval = false;
        let self = this;

        // Resgata lista de serviços
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/employee/services',
            successCallback: function(res) {
                console.log('crud_contracts.js/employee/services', 'onLoad', res);

                if (res.error) {
                    
                } else {
                    self.operatorAllowedServices = res.data;
                    let html = '<option selected default value="">-- Selecione uma opção --</option>';
                    for(let i in res.data) {
                        let serviceObj = res.data[i];
                        html += `
                            <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}'>${serviceObj.SERVICO}</option>
                        `;
                    }
                    $('#contract_update_service').html(html);
                    $('.js-contracts-services-list').html(html);
                    $('#edit_service_current_account_service').html(html);
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'crud_contracts.js/employee/services', 'onLoad', err);
            }
        });

        // Resgata lista de origens de pacientes
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/origins',
            successCallback: function(res) {
                if (!res.error) {
                    let options = res.data;
                    let optionsHtml = '';
                    for(let i in options) {
                        let option = options[i];
                        optionsHtml += `<option value="${option.ID}">${option.ORIGEM}</option>`;
                    }
                    $("#edit_patient_origin").html(optionsHtml);
                }
            },
            errorCallback: function(err) {

            }
        });

        // Resgata lista de planos
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/plans',
            successCallback: function(res) {
                if (!res.error) {
                    self.businessPlans = res.data;

                    let html = '<option selected default value="">-- Selecione --</option>';
                    for(let i = 0; i < res.data.length; i++) {
                        let plan = res.data[i];
                        html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}'>${plan.DESCRICAO}</option>`;
                    }
                    $('.js-contracts-plan-list').html(html);
                }
            },
            errorCallback: function(err) {
            }
        });

        // Resgata lista de tipos de serviço
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/service_type',
            successCallback: function(res) {
                if (!res.error) {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for(let i = 0; i < res.data.length; i++) {
                        let service = res.data[i];
                        html += `<option value="${service.ID}">${service.SERVICO}</option>`;
                    }
                    $('.js-contracts-service-type-list').html(html);
                }
            },
            errorCallback: function(err) {
            }
        });

        // Resgata lista de serviços
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/agenda_services',
            successCallback: function(res) {
                if (!res.error) {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for(let i = 0; i < res.data.length; i++) {
                        let service = res.data[i];
                        if (service.ID == 1 || service.ID == 3)
                            continue;
                        html += `<option value="${service.ID}" data-servico-info='${JSON.stringify(service)}'>${service.SERVICO}</option>`
                    }
                    $('.js-contracts-service-list').html(html);
                }
            },
            errorCallback: function(err) {
            }
        });

        // Resgata tipos de pacientes
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/patient_type',
            successCallback: function(res) {
                console.log('crud_contracts.js/business/patient_type', 'onLoad', res);

                if (res.error) {
                    
                } else {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for(let i in res.data) {
                        let serviceObj = res.data[i];
                        html += `
                            <option value="${serviceObj.ID}">${serviceObj.SIGLA}</option>
                        `;
                    }
                    $('#contract_update_patient_type').html(html);
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'crud_contracts.js/business/patient_type', 'onLoad', err);
            }
        });

        $('#edit_patient_postal_code').mask('00000-000', {
            onComplete: function(txt) { self.onFillPostalCode(txt); }
        });

        this.tableHandler = new TableBuilder({
            table: '#table-contracts-list',
            tableBody: '.js-contracts-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-contracts-per-page option:selected').val()),
            filter: false,
            maxPages: 0,
            customId: "CrudContractsHandler",
            tableRowRenderer: function(rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function() {
                self.fetchContractsList();
            },
            OnClickLastPage: function() {
                self.fetchContractsList();
            },
        });
        
        this.fetchContractsList();
        this.bindDomEvents();
        this.bindDomTableAndFilterEvents();
    }

    bindDomEvents() {
        this.contractInfo = null;

        let self = this;
        let contractPrinterType = null;

        $(".js-contracts-registrations-filter-form").on('submit', (e) => {
            e.preventDefault();
        });
    }

    bindDomTableAndFilterEvents() {
        let self = this;
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-contracts-registrations-branches-selector').change(function() {
            self.selectedBranch = $(this).val();
            // Caso tenha selecinado uma filial, mostra o campo para buscar pelo nome do paciente
            if (self.selectedBranch != '') {
                self.fetchContractsList();
            } else {
                self.selectedBranch = -1;
            }
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-contracts-registrations-start-date-input', function(e) {
            self.startDate = $(this).val();
            self.fetchContractsList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-contracts-registrations-end-date-input', function(e) {
            self.endDate = $(this).val();
            self.fetchContractsList();
        });

        // Detecta usuário configurando filtro qtd de registros por página
        $(document).on('change', '.js-contracts-per-page', function() {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchContractsList();
        });
    }

    fetchContractsList() {
        let self = this;
        $(".js-contracts-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest = apiCall({
            method: 'GET',
            endpoint: 'api/v1/contracts',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-contracts-per-page option:selected').val()),
                contractWithAttendedSessionsWithoutUpload: true,
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {},
                ...self.serviceId !== '' && self.serviceId !== null ? { serviceId: self.serviceId } : {},
                ...self.status !== '' && self.status !== null ? { status: self.status } : {}
            },
            successCallback: function(res) {
                $(".js-contracts-registrations-table").unblock();
                if (!res.error) {
                    console.log('crud_contracts.js/contracts', res);
                    self.contractsList = res.data;
                    self.contractsTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.contractsList, false, self.contractsTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function(err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow(rowData) {
        let html = '';
        let self = this;
        
        html += `
            <tr style="${rowData.UPLOAD_CONTRATO == 'N' && rowData.STATUS !== 'I' && rowData.STATUS !== 'C' ? 'background:yellow;' : ''}">
                <!-- button to open sessions -->
                <td data-label="Filial">${rowData.FILIAL_ID}</td>
                <td data-label="Nr Contrato">${rowData.ID}</td>
                <td data-label="Paciente ID">${rowData.CLIENTE_ID}</td>
                <td data-label="Paciente">${rowData.CLIENTE_NOME}</td>
                <td data-label="Data Adesão">${rowData.DATA_ADESAO_FORMATTED ? moment(rowData.DATA_ADESAO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY") : ""}</td>
                <td data-label="Qt Atendimento">${rowData.QT_ATENDIMENTOS}</td>
                <td data-label="Qt Arquivos">${parseInt(rowData.QT_ARQUIVOS) + parseInt(rowData.QT_ARQUIVOS_NOVO)}</td>
            </tr>
        `
        return html;
    }
}